import jwt from "jsonwebtoken"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Redirect, Route } from "react-router-dom"
import ErrorBoundary from "pages/Utilidades/ErrorBoundary"
import Page500 from "pages/Utilidades/Page500"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import { useErrorStore } from "store/useErrorStore"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  path,
  requiredRoles,
  ...rest
}) => {
  const { hasError500, errorPath } = useErrorStore(state => state.errorState)
  const clearError = useErrorStore(state => state.clearError)

  const location = useLocation()

  useEffect(() => {
    if (hasError500 && errorPath && location.pathname !== errorPath) {
      clearError()
    }
  }, [location.pathname, hasError500, errorPath, clearError])

  return (
    <ErrorBoundary
      fallback={
        <Layout>
          <Page500 />
        </Layout>
      }
    >
      {hasError500 ? (
        <Layout>
          <Page500 />
        </Layout>
      ) : (
        <Route
          {...rest}
          render={props => {
            const tempPass = jwt.decode(localStorage.getItem("token"))?.tempPas
            if (tempPass && path != "/password/update") {
              return (
                <Redirect
                  to={{
                    pathname: "/password/update",
                    state: { from: props.location },
                  }}
                />
              )
            }
            if (isAuthProtected) {
              if (!localStorage.getItem("token")) {
                return (
                  <Redirect
                    to={{ pathname: "/login", state: { from: props.location } }}
                  />
                )
              } else {
                if (path == "/password/update") {
                  return <Component {...props} />
                } else {
                  const roles = jwt.decode(localStorage.getItem("token"))?.roles
                  if (!roles) {
                    localStorage.removeItem("token")
                    return <Redirect to={{ pathname: "/login" }} />
                  }
                  if (requiredRoles) {
                    if (roles?.some(role => requiredRoles.includes(role))) {
                      return (
                        <Layout>
                          <Component {...props} />
                        </Layout>
                      )
                    } else {
                      return <Redirect to={{ pathname: "/indicadores" }} />
                    }
                  } else {
                    return (
                      <Layout>
                        <Component {...props} />
                      </Layout>
                    )
                  }
                }
              }
            } else {
              if (path == "/login" && localStorage.getItem("token")) {
                return (
                  <Redirect
                    to={{
                      pathname: "/indicadores",
                      state: { from: props.location },
                    }}
                  />
                )
              } else if (path == "/logout" && !localStorage.getItem("token")) {
                return (
                  <Redirect
                    to={{ pathname: "/login", state: { from: props.location } }}
                  />
                )
              } else {
                return <Component {...props} />
              }
            }
          }}
        />
      )}
    </ErrorBoundary>
  )
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware
